import _core from "./core";
import * as _imagesloaded2 from "imagesloaded";

var _imagesloaded = "default" in _imagesloaded2 ? _imagesloaded2.default : _imagesloaded2;

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

// imagesloaded
(function (window, factory) {
  // universal module definition
  if (exports) {
    // CommonJS
    exports = factory(_core, _imagesloaded);
  } else {
    // browser global
    factory(window.Flickity, window.imagesLoaded);
  }
})(typeof window != "undefined" ? window : exports, function factory(Flickity, imagesLoaded) {
  Flickity.create.imagesLoaded = function () {
    this.on("activate", (this || _global).imagesLoaded);
  };

  Flickity.prototype.imagesLoaded = function () {
    if (!(this || _global).options.imagesLoaded) return;

    let onImagesLoadedProgress = (instance, image) => {
      let cell = this.getParentCell(image.img);
      this.cellSizeChange(cell && cell.element);
      if (!(this || _global).options.freeScroll) this.positionSliderAtSelected();
    };

    imagesLoaded((this || _global).slider).on("progress", onImagesLoadedProgress);
  };

  return Flickity;
});

export default exports;